export enum LANGUAGE {
  EN = "en",
  DE = "de",
  FR = "fr"
}